import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import LogoFooter from "../../images/common/logo-footer.png";
import { FiInstagram } from "react-icons/fi";

export default function Footer() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <footer id="footer">
      <div id="footer1">
        <div className="content">
          <div className="row">
            <div className="col-4 row">
              <div className="col-5 logo">
                <img src={LogoFooter} />
                <div>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/fs_consultoria_juridica/"
                  >
                    <FiInstagram />
                  </a>
                </div>
              </div>
              <div className="col-7 menus">
                <Link className="font-weight-700" to="/">
                  Home
                </Link>
                <Link className="font-weight-700" to="/sobre">
                  Sobre
                </Link>
                <Link className="font-weight-700" to="/atuacao">
                  Atuação
                </Link>
                {/* <Link className="font-weight-700" to="/venda-de-precatorios">
                  Venda de Precatórios
                </Link> */}
                <Link className="font-weight-700" to="/blog">
                  Blog e Notícias
                </Link>
                <Link className="font-weight-700" to="/contato">
                  Contato
                </Link>
                {/* <Link className="cl-white menu-pp">Políticas de Privacidade</Link> */}
              </div>
            </div>
            <div className="col-8 row">
              <div className="col-5 ends">
                <span>Rio de Janeiro</span>
                <p>
                  Av. Rio Branco, 53 - 15° Andar, Sala 1501
                  <br />
                  Centro RJ - WhatsApp: (21) 3600-0590
                </p>
              </div>
              <div className="col-7 ends"></div>
              {/* <div className="col-12 infos">
                <p>
                  Artigo 286 do Código Civil “O credor pode ceder o seu crédito,
                  se a isso não se opuser a natureza da obrigação, a lei, ou a
                  convenção com o devedor; a cláusula proibitiva da cessão não
                  poderá ser oposta ao cessionário de boa-fé, se não constar do
                  instrumento da obrigação”.
                  <br />
                  <br />
                  Constituição Federal, artigo 100, parágrafo 13. “O credor
                  poderá ceder, total ou parcialmente, seus créditos em
                  precatórios a terceiros, independentemente da concordância do
                  devedor (…)”
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div id="footer2">
        <div className="content">
          <div className="row">
            <div className="col-12 col-lg-6 text-left alft">
              <span>
                Copyright © <strong>FS Gestão e Consultoria</strong> 2022
              </span>
            </div>
            <div className="col-12 col-lg-6 text-right alft justify-content-end">
              <span>
                Powered by{" "}
                <a href="https://somocollab.com" target="_blank">
                  Somo Collab
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
      <a
        className="whatappfixed"
        target="_blank"
        href="https://api.whatsapp.com/send/?phone=552136000590&text=Ol%C3%A1+quero+mais+informa%C3%A7%C3%B5es&type=phone_number&app_absent=0"
      >
        <img
          src="data:image/png;base64,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"
          alt="Whatsapp"
        />
      </a>
    </footer>
  );
}
